// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, Checkbox } from '@mui/material';
import { Heading, Label } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import silverAlphaLogo from '@shared/ui-kit/assets/img/silver-alpha.png';
import { useSilverAlphaWelcomeModal } from './use-silver-alpha-welcome-modal';
import styles from './silver-alpha-welcome-modal.module.css';

export const SilverAlphaWelcomeModal = defineComponent({
  displayName: 'SilverAlphaWelcomeModal',
  useSetup: useSilverAlphaWelcomeModal,
  View: ({
    ModalRenderer,
    acknowledged,
    onToggleAcknowledged,
    canAccess,
    onAccess,
  }) => (
    <ModalRenderer
      disableEscapeKeyDown
      maxWidth={false}
      PaperProps={{ className: styles.paper }}
      data-testid="silver-alpha-welcome-modal"
    >
      <div className={styles.body}>
        <header className={styles.header}>
          <img
            alt="Silver Alpha Asset Management SGIIC"
            className={styles.logo}
            data-testid="silver-alpha-welcome-logo"
            src={silverAlphaLogo}
          />
        </header>
        <div className={styles.content}>
          <div className={styles.intro}>
            <Heading
              className={styles.title}
              title={
                <Translation i18nKey="silver-alpha-welcome.title" ns="components" />
              }
              variant="h2"
            />
            <div className={styles.copy}>
              <p className={styles.paragraph}>
                <Translation
                  i18nKey="silver-alpha-welcome.body-provider"
                  ns="components"
                  components={[
                    <strong className="font-semibold text-title-main" />,
                  ]}
                />
              </p>
              <p className={styles.paragraph}>
                <Translation
                  i18nKey="silver-alpha-welcome.body-infrastructure"
                  ns="components"
                />
              </p>
            </div>
          </div>
          <div className={styles.actions}>
            <div className={styles.acknowledgement}>
              <Checkbox
                checked={acknowledged}
                className="!p-0"
                data-testid="silver-alpha-welcome-checkbox"
                id="silver-alpha-welcome-acknowledgement"
                onChange={onToggleAcknowledged}
                required
              />
              <Label
                className={styles['acknowledgement-label']}
                htmlFor="silver-alpha-welcome-acknowledgement"
              >
                <Translation
                  i18nKey="silver-alpha-welcome.acknowledgement"
                  ns="components"
                />
              </Label>
            </div>
            <Button
              color="secondary"
              data-testid="silver-alpha-welcome-access-button"
              disabled={!canAccess}
              fullWidth
              onClick={onAccess}
              size="large"
              variant="contained"
            >
              <Translation i18nKey="silver-alpha-welcome.access" ns="components" />
            </Button>
          </div>
        </div>
      </div>
    </ModalRenderer>
  ),
});
